import axios from 'axios'
import {
    ElMessage
} from "element-plus";
import storage from '../utils/storage'
import router from '../route/index'; 

// Flag to prevent multiple redirects
let isRedirecting = false;

const service = axios.create({
    baseURL: '/api',
    // set timeout
    timeout: 30000
})
service.setAuthorization = (token) => {
    if (token) {
        service.defaults.headers.common['Authorization'] = `Bearer ${token}`; // 设置请求头的 Authorization
    } else {
        delete service.defaults.headers.common['Authorization']
    }
}
service.interceptors.request.use(
    config => {
        config.headers = config.headers || {}
        const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData
        if (isFormData) {
            delete config.headers['Content-Type']
        } else if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json'
        }

        let tokenInfo = storage.get('TOKEN')
        const token = tokenInfo ? tokenInfo : null

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // 设置请求头的 Authorization
        }

        return config
    },
    error => {
        console.log(error);
        return Promise.reject(error)
    }
)
service.interceptors.response.use(
    // success
    response => {
        const res = response.data
        // if (res.code == 0) {
        //      const res2 = {
        //         code: res.code,
        //         data: JSON.parse(JSON.stringify(res.data)),
        //         msg: res.msg
        //     }
        //     return res2
        // }
        return res
    },
    error => {
        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                // Only 401 means that the current authentication is no longer valid.
                if (!isRedirecting) {
                    isRedirecting = true;

                    console.warn(`Authentication error (${status}):`, error.response.data);

                    ElMessage({
                        message: "Session expired, please log in again",
                        type: "warning",
                        duration: 2000,
                    });
                    
                    // Clear stored token and user data
                    storage.remove('TOKEN');
                    storage.remove('USER');
                    
                    // Delay redirect slightly to allow message to show
                    setTimeout(() => {
                        router.push('/login').then(() => {
                            isRedirecting = false;
                        }).catch(err => {
                            console.error('Redirect error:', err);
                            isRedirecting = false;
                        });
                    }, 500);
                }
            } else if (status === 403) {
                // A valid session can still be forbidden from a specific resource.
                // Do not clear the token or redirect to login in that case.
                const errorMsg = error.response.data?.msg || "You do not have permission to perform this action";
                ElMessage({
                    message: errorMsg,
                    type: "error",
                    duration: 3000,
                });
                console.warn("Permission denied:", error.response.data);
            } else if (status === 408) {
                ElMessage({
                    message: "Request timeout, please try again.",
                    type: "error",
                    duration: 3000,
                });
            } else if (status === 422) {
                // Validation error
                const errorMsg = error.response.data?.msg || error.response.data?.message || "Validation error";
                ElMessage({
                    message: errorMsg,
                    type: "error",
                    duration: 3000,
                });
            } else if (status >= 500) {
                // Server error
                ElMessage({
                    message: "Server error, please try again later.",
                    type: "error",
                    duration: 3000,
                });
                console.error('Server error:', error.response);
            } else {
                // Other errors
                const errorMsg = error.response.data?.msg || error.response.data?.message || "An unexpected error occurred";
                ElMessage({
                    message: errorMsg,
                    type: "error",
                    duration: 3000,
                });
            }
        } else if (error.request) {
            // Request was made but no response received
            ElMessage({
                message: "Network error: Unable to reach server",
                type: "error",
                duration: 3000,
            });
            console.error('Network error:', error.request);
        } else {
            // Something else happened
            ElMessage({
                message: "Request error: " + error.message,
                type: "error",
                duration: 3000,
            });
            console.error('Request error:', error.message);
        }
        return Promise.reject(error);
    }
)
export default service
